const entities: Record<string, string> = {
  amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", nbsp: " ",
  ndash: "–", mdash: "—", lsquo: "‘", rsquo: "’", ldquo: "“", rdquo: "”",
  hellip: "…", bull: "•", middot: "·", times: "×", divide: "÷", plusmn: "±",
  micro: "µ", deg: "°", sup2: "²", sup3: "³", le: "≤", ge: "≥",
};

const decodeEntities = (text: string): string =>
  text.replace(/&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]+);/gi, (entity, name: string) => {
    if (!name.startsWith("#")) return entities[name] ?? entity;
    const hex = name[1].toLowerCase() === "x";
    const value = parseInt(name.slice(hex ? 2 : 1), hex ? 16 : 10);
    return value > 0 && value <= 0x10ffff && !(value >= 0xd800 && value <= 0xdfff)
      ? String.fromCodePoint(value)
      : entity;
  });

/** Display only: keep the original excerpt intact for exact citation provenance.
 * Never mount source HTML. Row breaks and cell separators retain table meaning,
 * including quotations that start/end partway through the source's HTML.
 * Keep this transformation in sync with ReferenceExcerpt in iOS Models.swift.
 */
export const formatReferenceExcerpt = (excerpt: string = ""): string => {
  let text = excerpt;
  for (let pass = 0; pass < 3; pass += 1) text = decodeEntities(text);
  text = text.replace(/\\([<>/~])/g, "$1");
  // A retrieved span can begin inside a style attribute, as in "wrap: break-word;'>".
  text = text.replace(/^\s*[^<>\n]*(?:wrap|align|style|padding|border|width|height)\s*[:=][^<>\n]*['"]\s*>/i, "");
  text = text.replace(/<!--[^]*?(?:-->|$)/g, "");
  text = text.replace(/<(script|style|iframe|object)\b[^>]*>[^]*?(?:<\/\1\s*>|$)/gi, "");
  text = text.replace(/<\/(?:td|th)\s*>\s*(?:<(?:td|th)\b[^>]*>)/gi, " | ");
  text = text.replace(/<\/?(?:table|thead|tbody|tfoot|tr|p|div|li|ul|ol|h[1-6]|blockquote)\b[^>]*>|<br\b[^>]*>/gi, "\n");
  // Match actual tags, not clinical comparisons such as "<6 cm" or "< 5".
  text = text.replace(/<\/?[a-z][a-z0-9-]*(?:\s+[^<>]*?)?\s*\/?>/gi, "");
  text = text.replace(/<\/?(?:td|th|tr|table|span|div|p)\b[^<>]*$/gi, "");
  return text.split(/\r?\n/).map(line => line.replace(/[\t \u00a0]+/g, " ").trim())
    .filter(Boolean).join("\n");
};
